// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInCreateNewAccountStyles } from "@guestsupply/Overrides/Widgets/SignIn/SignInCreateNewAccount";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

signInCreateNewAccountStyles.signInCreateNewAccountGridContainer = {
    gap: 0,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    variant: "h2",
    as: "p",
    css: css`
        margin-bottom: 16px;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitleGridItem = {
    width: 12,
};

signInCreateNewAccountStyles.signInCreateNewAccountTextGridItem = {
    width: 12,
};

signInCreateNewAccountStyles.signInCreateNewAccountText = {
    size: 14,
    css: css`
        margin-bottom: 20px;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem = {
    width: 12,
    css: css`
        gap: 12px;
        flex-direction: row;
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};

signInCreateNewAccountStyles.createNewAccountButton = {
    variant: "tertiary",
    css: css`
        padding: 0 18px;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

signInCreateNewAccountStyles.requestAccessButton = {
    css: css`
        padding: 0 18px;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
